// extracted by mini-css-extract-plugin
module.exports = {"ModalHeader":"ModalEditFacilityService_ModalHeader__3hECJ","ModalBody":"ModalEditFacilityService_ModalBody__3WrTJ","ButtonClose":"ModalEditFacilityService_ButtonClose__BR29U"};